import React from 'react';
import {AvForm, AvInput, AvField} from 'availity-reactstrap-validation';
import {Button, Container, Row, Col} from "reactstrap";
import {postMessage} from '../api/';
import {getApiErrorMessage} from '../api/errors';
import CaptchaChallenge, {useCaptcha} from './CaptchaChallenge';

export default () => {  
  const [messageSent, setMessageSent] = React.useState(false);
  const [error, setError] = React.useState('');
  const captcha = useCaptcha();

  const handleValidSubmit = async (_, values) => {
    setError('');

    const recaptchaToken = await captcha.execute('message');
    if (!recaptchaToken) return;

    values.concerning = values.concerning ? values.concerning : "Offers, New Business, Partnerships";
    values.recaptcha_token = recaptchaToken;
    values.recaptcha_action = 'message';

    try {
      await postMessage(values);
      setMessageSent(true);
    } catch (error) {
      setError(getApiErrorMessage(error, 'Unable to send your message. Please try again.'));
    }
  }

  return (
    <section className="section section-light" id="contact">
      <h2 className="text-center">Contact the EDIfly team!</h2>
      {!messageSent ? 
      <Container className="px-3">
        <Row>
          <Col className="mx-auto" md="8">
            <AvForm className="contact-form" onValidSubmit={handleValidSubmit}>
              <Row>
                <Col lg="6">
                  <label>Name</label>
                  <AvInput placeholder="John Doe" type="text" name="name" required />
                </Col>
                <Col lg="6">
                  <label>Company</label>
                  <AvInput placeholder="EDIfly" type="text" name="company" />
                </Col>
                <Col lg="6">
                  <label>Email Address</label>
                  <AvInput placeholder="john.doe@example.com" type="email" name="email" required />
                </Col>
                <Col lg="6">
                  <label>Concerning</label>
                  <AvField type="select" name="concerning">
                    <option>Try B4 You Buy</option>
                    <option>Offers, New Business, Partnerships</option>
                    <option>Media Enquiries</option>
                    <option>Support/Customer Service Enquiries</option>
                  </AvField>
                </Col>
              </Row>
              <label>How can we help you to create value with EDIfly?</label>
              <AvInput placeholder="Message" type="textarea" rows="4" name="message" required />
              <CaptchaChallenge captcha={captcha} />
              <Row className="justify-content-center">
                <Col xs="6" md="4">
                  <Button color="success" size="lg" type="submit">Send Message</Button>
                </Col>
              </Row>
              {error && <p className="text-danger text-center mb-0 mt-3">{error}</p>}
            </AvForm>
          </Col>
        </Row>
      </Container>
      : 
      <Container>
        <Row className="justify-content-center">
          <h3 style={{color: 'green'}}>Message Sent</h3>
        </Row>  
      </Container>}
    </section>
  )
}
